import { getPermissions } from "@/helper/collection";
import { authenticationService } from "@/services/AuthenticationService";

export const SignageRoutes = {
  path: "signages",
  name: "Signages",
  redirect: "signages/display-list",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "display-list",
      name: "Display List",
      component: () =>
        import("@/components/NewSignage/signage-display-list.vue"),
      meta: {}
    },
    {
      path: "add-display",
      name: "Add Display",
      component: () =>
        import("@/components/NewSignage/add-signage-display.vue"),
      meta: {}
    },
    {
      path: "edit-display/:display_id",
      name: "Edit Display Signage",
      component: () =>
        import("@/components/NewSignage/add-signage-display.vue"),
      meta: {}
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/signageRoutes.js